import React from 'react';
import c from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import DiscordIcon from '@wix/da-ds/pkg/Icons/16x16/Discord';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './Benefit.scss';
var Benefit = function (_a) {
    var benefit = _a.benefit, isDiscord = _a.isDiscord, className = _a.className;
    return (React.createElement(Flex, { className: c(s['root'], className), alignItems: "flex-start" },
        isDiscord ? (React.createElement(DiscordIcon, { className: c(s['icon'], s['icon-discord']), size: IconSize.SMALLER, disableDefaultColors: true })) : (React.createElement(CheckIcon, { className: c(s['icon'], s['icon-check']), size: IconSize.SMALLER, disableDefaultColors: true })),
        React.createElement("span", null, benefit)));
};
Benefit.displayName = 'Benefit';
export default Benefit;
//# sourceMappingURL=Benefit.js.map